//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
// import './style.scss'
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';

function Page() {
  const changeMotivation = useStore((state) => state.changeMotivation);
  const setChangeMotivation = useStore((state) => state.setChangeMotivation);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.changeMotivation.title')}</Title>
        <Text size='m' medium className={'description'} style={{ padding: 0 }}>
          {t('onboarding.changeMotivation.subTitle')}
        </Text>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={changeMotivation}
          onChange={(value) => {
            setChangeMotivation(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'change-motivation',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'It stays consistent'}>
            {t('onboarding.changeMotivation.options.consistent')}
          </Option>
          <Option value={'It ebbs and flow'}>
            {t('onboarding.changeMotivation.options.ebbsAndFlow')}
          </Option>
          <Option value={'Im still finding it'}>
            {t('onboarding.changeMotivation.options.stillFinding')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
